export default __webpack_public_path__ + "static/media/iranyekanwebregular.85048835.woff";